module.exports = __webpack_public_path__ + "img/male-doctor-avatar.652fb1f0.png";